import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/src/shape-component"
import Row from "components/table/row"

export default memo(shapeComponent(class CardTableRow extends ShapeComponent {
  render() {
    return (
      <Row {...this.props} />
    )
  }
}))
